import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=ba59d6cc&scoped=true"
import script from "./DownloadSection.vue?vue&type=script&lang=js"
export * from "./DownloadSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadSection.vue?vue&type=style&index=0&id=ba59d6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba59d6cc",
  null
  
)

export default component.exports